import React from "react";
import CheckoutForm from "./CheckoutForm";

const statusLabels = {
    pending: "ממתין לאישור",
    success: "הצלחה",
    failed: "כשלון"
};

const currencyLabels = {
    ILS: "שקל חדש",
    USD: "דולר אמריקאי",
    EUR: "אירו"
};

const DonationForm = ({
    formData,
    updating = false,
    logic = {},
    onSubmit
}) => {

    const {
        checkoutRef,
        perInstallment,
        isFieldDisabled = () => false,
        handleChange,
        handlePaymentMethodChange,
        handleCreditPayment,
        creditFailed,
        setIsCreditReady
    } = logic;

    const todayStr = new Date().toISOString().split('T')[0];
    // הגנה למקרה שהלוגיקה עדיין בטעינה
    if (!handleChange) return <div className="donation-page">טוען לוגיקה...</div>;

    const shouldRunCreditPayment =
        formData.paymentMethod === "credit" &&
        (!updating || formData.status === "failed");
    const handleSubmit = (e) => {
        e.preventDefault();

        // בדיקת תאריך קשיחה לאשראי
        if (formData.paymentMethod === "credit") {
            const selectedDate = new Date(formData.date).setHours(0, 0, 0, 0);
            const today = new Date().setHours(0, 0, 0, 0);

            if (selectedDate < today) {
                alert("שגיאה: לא ניתן לבצע סליקה בתאריך מהעבר. אנא בחרי תאריך מהיום והלאה.");
                return; // עוצר את השליחה ולא מגיע ל-handleCreditPayment
            }
        }

        if (shouldRunCreditPayment) {
            handleCreditPayment();
        } else {
            onSubmit(formData);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="donation-form">
            {/* סכום ומטבע */}
            <div className="form-row">
                <div className="form-group">
                    <label>סכום</label>
                    <input
                        type="text"
                        name="amount"
                        value={formData.amount || ""}
                        onChange={handleChange}
                        pattern="\d*"
                        inputMode="numeric"
                        required
                        disabled={isFieldDisabled("amount")}
                        className={isFieldDisabled("amount") ? "disabled-field" : ""}
                    />
                </div>
                <div className="form-group">
                    <label>מטבע</label>
                    <select
                        name="currency"
                        value={formData.currency}
                        onChange={handleChange}
                        disabled={isFieldDisabled("currency")}
                        className={isFieldDisabled("currency") ? "disabled-field" : ""}
                    >
                        {Object.keys(currencyLabels).map(code => (
                            <option key={code} value={code}>{currencyLabels[code]}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* תאריך ואמצעי תשלום */}
            <div className="form-row">
                <div className="form-group">
                    <label>תאריך תרומה</label>
                    <input
                        type="date"
                        name="date"
                        value={formData.date ? formData.date.slice(0, 10) : ""}
                        onChange={handleChange}
                        // הוספת הגבלת מינימום רק אם זה אשראי
                        min={formData.paymentMethod === "credit" ? todayStr : undefined}
                        disabled={isFieldDisabled("date")}
                        className={isFieldDisabled("date") ? "disabled-field" : ""}
                    />
                </div>
                <div className="form-group">
                    <label>אמצעי תשלום</label>
                    <select
                        name="paymentMethod"
                        value={formData.paymentMethod}
                        onChange={handlePaymentMethodChange}
                        disabled={updating}
                        className="payment-method-select"
                    >
                        <option value="credit">אשראי</option>
                        <option value="recurring">הוראת קבע</option>
                        <option value="cash">מזומן</option>
                        <option value="manual">הזנה ידנית</option>
                    </select>
                </div>
            </div>


            {formData.paymentMethod === "credit" && (
                <div className="credit-details">
                    <div className="form-row">
                        <div className="form-group">
                            <label>{updating ? "פרטי כרטיס" : "שם בעל הכרטיס"}</label>
                            <input
                                type="text"
                                name="cardHolderName"
                                value={formData.cardHolderName || ""}
                                onChange={handleChange}
                                required={!updating}
                                disabled={updating && formData.status === "success"}
                                placeholder=""
                            />
                        </div>

                        {!updating ? (
                            <div className="form-group">
                                <label>תעודת זהות</label>
                                <input
                                    type="text"
                                    name="cardHolderId"
                                    value={formData.cardHolderId || ""}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        ) : (
                            <div className="form-group">
                                <label>סטטוס תשלום</label>
                                <input
                                    type="text"
                                    value={statusLabels[formData.status] || ""}
                                    disabled
                                    className={`status-badge ${formData.status}`}
                                />
                            </div>
                        )}
                    </div>

                    {Number(formData.amount) > 0 && (shouldRunCreditPayment || creditFailed) ? (
                        <div className="stripe-element-container" style={{ marginTop: '20px', padding: '15px', border: '1px solid #eee', borderRadius: '8px' }}>
                            <label style={{ marginBottom: '10px', display: 'block', fontWeight: 'bold' }}>פרטי כרטיס אשראי (מאובטח)</label>
                            <CheckoutForm
                                ref={checkoutRef}
                                amount={formData.amount}
                                currency={formData.currency}
                                cardHolderName={formData.cardHolderName}
                                cardHolderId={formData.cardHolderId}
                                onPaymentReady={setIsCreditReady}
                            />
                        </div>
                    ) : (

                        !updating && (!formData.amount || Number(formData.amount) <= 0) && (
                            <p style={{ color: '#666', fontSize: '0.9em' }}>* יש להזין סכום תרומה כדי להזין פרטי אשראי</p>
                        )
                    )}
                </div>
            )}
            {/* הוראת קבע */}
            {formData.paymentMethod === "recurring" && (
                <div className="recurring-details">
                    <div className="form-row">
                        <div className="form-group">
                            <label>מספר בנק</label>
                            <input type="text" name="bankNumber" minLength={2} maxLength={3}
                                value={formData.bankNumber || ""} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label>מספר חשבון</label>
                            <input type="text" name="bankAccount" minLength={6} maxLength={10}
                                value={formData.bankAccount || ""} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label>סניף</label>
                            <input type="text" name="bankBranch" minLength={3} maxLength={4}
                                value={formData.bankBranch || ""} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label>שם בעל החשבון</label>
                            <input type="text" name="accountHolder"
                                value={formData.accountHolder || ""} onChange={handleChange} required />
                        </div>
                    </div>
                </div>
            )}

            {/* תשלומים */}
            <div className="form-row">
                <div className="form-group">
                    <label>תשלומים</label>
                    <input
                        type="number"
                        name="installments"
                        min="1"
                        step="1"
                        value={formData.installments || 1}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                                handleChange(e);
                                return;
                            }

                            const numericVal = Math.max(1, Math.floor(Number(val)));
                            e.target.value = numericVal;
                            handleChange(e);
                        }}
                        disabled={isFieldDisabled("installments")}
                        className={isFieldDisabled("installments") ? "disabled-field" : ""}
                    />
                    <strong>
                        {formData.installments > 1
                            ? `סה"כ: ${formData.amount}, כל תשלום: ${perInstallment}`
                            : `סה"כ: ${formData.amount}`}
                    </strong>
                </div>
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label>מספר קבלה</label>
                    <input
                        type="number"
                        name="receipt_id"
                        value={formData.receipt_id || ""}
                        onChange={handleChange}
                        disabled={isFieldDisabled("receipt_id")}
                        className={isFieldDisabled("receipt_id") ? "disabled-field" : ""}
                    />
                </div>
            </div>

            <div className="form-group full-width">
                <label>הערות</label>
                <textarea
                    name="notes"
                    value={formData.notes || ""}
                    onChange={handleChange}
                    disabled={isFieldDisabled("notes")}
                    className={isFieldDisabled("notes") ? "disabled-field" : ""}
                />
            </div>

            {/* <button
                type="submit"
                className="submit-btn"
            >
                {formData.paymentMethod === "credit" && !updating
                    ? "סליקת אשראי ושמירת התרומה"
                    : updating
                        ? "עדכון תרומה"
                        : "שמירת תרומה"
                }
            </button> */}
            <button type="submit" className="submit-btn-styled">
                <span className="btn-icon">
                    {updating ? (
                        /* אייקון עריכה לעדכון */
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor">
                            <path d="M12 20h9" strokeWidth="2" />
                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" strokeWidth="2" />
                        </svg>
                    ) : (
                        /* אייקון פלוס מעוגל להוספה */
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="16" />
                            <line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                    )}
                </span>
                <span className="btn-text">
                    {formData.paymentMethod === "credit" && !updating
                        ? "סליקת אשראי ושמירת התרומה"
                        : updating
                            ? "עדכון תרומה"
                            : "הוספת תרומה"
                    }
                </span>


            </button>
        </form>
    );
};

export default DonationForm;